import React, { useContext, useEffect, useRef } from 'react';
import { FormContext } from '../common/form/FormContext';
import { V } from '../common/Layout';
import { attributeEditors, Field } from './attributes';
import FormPanel from '../common/form/FormPanel';

export type ValueEditorProps = {
    fields: Array<Field>;
    initialValues?: object;
};

export default (props: ValueEditorProps) => {
    const { fields, initialValues } = props;
    const { setState } = useContext(FormContext);
    const hasInitialized = useRef(false);

    useEffect(() => {
        if (initialValues && !hasInitialized.current) {
            setState((prevState) => ({ ...prevState, ...initialValues }));
            hasInitialized.current = true;
        }
    }, [initialValues, setState]);

    return (
        <V sx={{ flexGrow: 1 }}>
            <FormPanel>
                {fields.map((field, index) => {
                    const Editor = attributeEditors[field.fieldType];
                    return <Editor key={index} field={field} />;
                })}
            </FormPanel>
        </V>
    );
};
